import dayjs from 'dayjs';
export default ($i18n) => {
    return {
        type: 'object',
        properties: {
            dates: {
                type: 'array',
                title: '',
                // colSpan: 'full',
                'x-decorator': 'CnFormItem',
                'x-component': 'CnArrayTable',
                'x-component-props': {
                    pagination: {
                        pageSize: 1000,
                    },
                    style: {
                        width: '100%',
                    },
                },
                items: {
                    type: 'object',
                    properties: {
                        startDate: {
                            type: 'void',
                            'x-component': 'CnArrayTableColumn',
                            'x-component-props': {
                                width: 200,
                                title: $i18n.get({
                                    id: 'StartTimeDimension',
                                    dm: '开始时间维度',
                                }),
                            },
                            properties: {
                                dateStart: {
                                    required: true,
                                    requiredMessage: $i18n.get({
                                        id: 'PleaseSelectAStartTimeDimension_849100734',
                                        dm: '请选择开始时间维度',
                                    }),
                                    type: 'string',
                                    'x-decorator': 'CnFormItem',
                                    'x-component': 'CnAsyncSelect',
                                    'x-component-props': {
                                        hasClear: true,
                                        dataSource: [
                                            {
                                                label: $i18n.get({ id: 'Today', dm: '今天' }),
                                                value: $i18n.get({ id: 'Today', dm: '今天' }),
                                            },
                                            {
                                                label: $i18n.get({ id: 'Yesterday', dm: '昨天' }),
                                                value: $i18n.get({ id: 'Yesterday', dm: '昨天' }),
                                            },
                                            {
                                                label: $i18n.get({
                                                    id: 'TheDayBeforeYesterday',
                                                    dm: '前天',
                                                }),
                                                value: $i18n.get({
                                                    id: 'TheDayBeforeYesterday',
                                                    dm: '前天',
                                                }),
                                            },
                                            {
                                                label: $i18n.get({
                                                    id: 'LastMonthsToday',
                                                    dm: '上个月的今天',
                                                }),
                                                value: $i18n.get({
                                                    id: 'LastMonthsToday',
                                                    dm: '上个月的今天',
                                                }),
                                            },
                                        ],
                                    },
                                },
                            },
                        },
                        startTime: {
                            type: 'void',
                            'x-component': 'CnArrayTableColumn',
                            'x-component-props': {
                                width: 200,
                                title: $i18n.get({ id: 'StartTime', dm: '开始时间' }),
                            },
                            properties: {
                                timeStart: {
                                    required: true,
                                    requiredMessage: $i18n.get({
                                        id: 'PleaseSelectAStartTime',
                                        dm: '请选择开始时间',
                                    }),
                                    'x-decorator': 'CnFormItem',
                                    'x-component': 'CnTimePickerPro',
                                    'x-component-props': {
                                        hasClear: true,
                                        outputFormat: 'HH:mm:ss',
                                        preset: [
                                            {
                                                label: $i18n.get({ id: 'AtTheMoment', dm: '此刻' }),
                                                value: () => dayjs(new Date()),
                                            },
                                        ],
                                    },
                                },
                            },
                        },
                        endDate: {
                            type: 'void',
                            'x-component': 'CnArrayTableColumn',
                            'x-component-props': {
                                width: 200,
                                title: $i18n.get({
                                    id: 'EndTimeDimension',
                                    dm: '结束时间维度',
                                }),
                            },
                            properties: {
                                dateEnd: {
                                    required: true,
                                    requiredMessage: $i18n.get({
                                        id: 'PleaseSelectAnEndTimeDimension_1469835075',
                                        dm: '请选择结束时间维度',
                                    }),
                                    type: 'string',
                                    'x-decorator': 'CnFormItem',
                                    'x-component': 'CnAsyncSelect',
                                    'x-component-props': {
                                        hasClear: true,
                                        dataSource: [
                                            {
                                                label: $i18n.get({ id: 'Now', dm: '现在' }),
                                                value: $i18n.get({ id: 'Now', dm: '现在' }),
                                            },
                                            {
                                                label: $i18n.get({ id: 'Today', dm: '今天' }),
                                                value: $i18n.get({ id: 'Today', dm: '今天' }),
                                            },
                                            {
                                                label: $i18n.get({ id: 'Yesterday', dm: '昨天' }),
                                                value: $i18n.get({ id: 'Yesterday', dm: '昨天' }),
                                            },
                                            {
                                                label: $i18n.get({
                                                    id: 'TheDayBeforeYesterday',
                                                    dm: '前天',
                                                }),
                                                value: $i18n.get({
                                                    id: 'TheDayBeforeYesterday',
                                                    dm: '前天',
                                                }),
                                            },
                                            {
                                                label: $i18n.get({
                                                    id: 'LastMonthsToday',
                                                    dm: '上个月的今天',
                                                }),
                                                value: $i18n.get({
                                                    id: 'LastMonthsToday',
                                                    dm: '上个月的今天',
                                                }),
                                            },
                                        ],
                                    },
                                },
                            },
                        },
                        endTime: {
                            type: 'void',
                            'x-component': 'CnArrayTableColumn',
                            'x-component-props': {
                                width: 200,
                                title: $i18n.get({ id: 'EndTime', dm: '结束时间' }),
                            },
                            properties: {
                                timeEnd: {
                                    // required: true,
                                    requiredMessage: $i18n.get({
                                        id: 'PleaseSelectAnEndTime',
                                        dm: '请选择结束时间',
                                    }),
                                    'x-decorator': 'CnFormItem',
                                    'x-component': 'CnTimePickerPro',
                                    'x-component-props': {
                                        hasClear: true,
                                        outputFormat: 'HH:mm:ss',
                                        preset: [
                                            {
                                                label: $i18n.get({ id: 'AtTheMoment', dm: '此刻' }),
                                                value: () => dayjs(new Date()),
                                            },
                                        ],
                                    },
                                },
                            },
                        },
                        operations: {
                            type: 'void',
                            'x-component': 'CnArrayTableColumn',
                            'x-component-props': {
                                title: $i18n.get({ id: '31255239218827264.CNTM', dm: '操作' }),
                                dataIndex: 'operations',
                                width: 50,
                                fixed: 'right',
                            },
                            properties: {
                                item: {
                                    type: 'void',
                                    'x-component': 'CnFormItem',
                                    properties: {
                                        remove: {
                                            type: 'void',
                                            'x-component': 'CnArrayTableRemove',
                                        },
                                        // 如不需要自定义操作可自行删除
                                        custom: {
                                            type: 'void',
                                            'x-component': 'CustomAction',
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
                properties: {
                    // 用于增加行
                    add: {
                        type: 'void',
                        title: $i18n.get({ id: 'AddTime', dm: '添加时间' }),
                        'x-component': 'CnArrayTableAddition',
                    },
                },
            },
        },
    };
};
